import { useRef, useEffect, useState } from 'react';
import "../styles.css";
import { pdf, PDFViewer } from '@react-pdf/renderer';
import PDFCotizacion from './PDFCotizacion';
import calcularTotales from '../utils/calcularTotales';
import { db } from '../services/firebase';
import { guardarCotizacionEnFirestore } from "../services/guardarCotizacionEnFirestore";
import { doc, getDoc, updateDoc } from 'firebase/firestore';

function CotizadorForm({ rol }) {
    const [tasaCambio, setTasaCambio] = useState(4500); // Valor inicial editable
    const isAdmin = rol === "admin";
    const [moneda, setMoneda] = useState("COP");
    const [tasaCambioAuto, setTasaCambioAuto] = useState(null);
    const [camposExtras, setCamposExtras] = useState([]);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [editandoTarifas, setEditandoTarifas] = useState(false);
    const [isGenerating] = useState(false);
    const totalRef = useRef();
    const [mostrarFlotante, setMostrarFlotante] = useState(false);
    const agregarCampoExtra = () => {
        setCamposExtras([...camposExtras, { nombre: '', valor: '' }]);
    };
    const actualizarCampoExtra = (index, key, value) => {
        const nuevosCampos = [...camposExtras];
        nuevosCampos[index][key] = value;
        setCamposExtras(nuevosCampos);
    };

    const eliminarCampoExtra = (index) => {
        const nuevosCampos = [...camposExtras];
        nuevosCampos.splice(index, 1);
        setCamposExtras(nuevosCampos);
    };

    const guardarTarifas = async () => {
        try {
            await updateDoc(doc(db, "datos", "ZsFuNwLyebPJ2CZqMkKB"), tarifas);
            alert("✅ Tarifas actualizadas correctamente");
            setEditandoTarifas(false);
        } catch (error) {
            console.error(error);
            alert("❌ Error al guardar tarifas");
        }
    };

    const [form, setForm] = useState({
        retencionIVA: false,
        retencionReteFuente: false,
        retencionReteICA: false,
        retencionReteIVA: false,
        nombreCliente: '',
        nombreProyecto: '',
        numeroTorres: '',
        vueloTorre: '',
        animacionVuelo: '',
        rendersDisponibilidad: '',
        unidadesHabitacionales: 0,
        crearRenders: false,
        maquetaVirtual: false,
        animacionLuma: '',
        renderPlantasTipoTorre: '',
        renderPlantaAptoTipico: '',
        plantasArquitectonicasCotas: '',
        videoAnimacion: '',
        incluirVueloDrone: false,
        renderInteriores: '',
        descripcionRenderPlantasTipoTorre: '',
        descripcionRenderPlantasAptoTipico: '',
        descripcionRenderInteriores: '',
        descripcionRenderExterior: '',
        descripcionRenderFotomontaje: '',
        descripcionRenderAmenties: '',
        descripcionRenderArquitectonicas: '',
        renderExterior: '',
        renderFotomontaje: '',
        animacionIntro: '',
        renderAmenties: '',
        descuentoValor: '',
        descuentoPorcentaje: '',
        interiores360: '',
        esCotizacionNueva: 'No',
        realizadaPor: '',
        idCliente: '',
        correoCliente: '',
        telefonoCliente: '',
        vueloDrone: 2600000,
        formaPago: 'Completo',
        notaPagoCuotas: '',
    });
    const [tarifas, setTarifas] = useState(null);
    const [mostrarPreview, setMostrarPreview] = useState(false);


    const InfoTooltip = ({ image, text }) => {
        const [isMobile, setIsMobile] = useState(false);
        const [open, setOpen] = useState(false);

        useEffect(() => {
            const checkMobile = () =>
                setIsMobile(window.innerWidth < 768);

            checkMobile();
            window.addEventListener("resize", checkMobile);
            return () => window.removeEventListener("resize", checkMobile);
        }, []);

        return (
            <>
                <div
                    className="info-icon"
                    onClick={() => isMobile && setOpen(true)}
                    style={{ display: "inline-flex" }}
                >
                    ?
                    {/* 🔹 HOVER EN DESKTOP */}
                    {!isMobile && (
                        image ? (
                            <div className="tooltip-image">
                                <img src={image} alt="Ejemplo render" />
                            </div>
                        ) : (
                            text && (
                                <div className="tooltip-text-box">
                                    {text}
                                </div>
                            )
                        )
                    )}
                </div>

                {/* 🔹 MODAL EN MOBILE */}
                {open && (
                    <div className="modal-overlay" onClick={() => setOpen(false)}>
                        <div className="modal-content">
                            {image && <img src={image} alt="Ejemplo render" />}
                            {text && <p>{text}</p>}
                        </div>
                    </div>
                )}
            </>
        );
    };



    useEffect(() => {
        const refActual = totalRef.current; // ✅ guarda una copia segura

        const observer = new IntersectionObserver(
            ([entry]) => setMostrarFlotante(!entry.isIntersecting),
            { threshold: 1.0 }
        );

        if (refActual) {
            observer.observe(refActual);
        }

        return () => {
            if (refActual) {
                observer.unobserve(refActual);
            }
        };
    }, []);


    useEffect(() => {
        if (tarifas?.TasaCambio) {
            setTasaCambio(tarifas.TasaCambio);
        }
    }, [tarifas]);


    useEffect(() => {
        const obtenerTasa = async () => {
            try {
                const res = await fetch('https://api.exchangerate-api.com/v4/latest/USD');
                const data = await res.json();
                const tasa = data.rates.COP;
                setTasaCambio(tasa);
                setTasaCambioAuto(tasa);
            } catch (error) {
                console.error('❌ Error al obtener la tasa de cambio:', error);
            }
        };

        obtenerTasa();
    }, []);

    useEffect(() => {
        const fetchTarifas = async () => {
            try {
                const docRef = doc(db, 'datos', 'ZsFuNwLyebPJ2CZqMkKB'); // colección y documento
                const docSnap = await getDoc(docRef);

                if (docSnap.exists()) {
                    setTarifas(docSnap.data());
                } else {
                    console.error('No se encontró el documento de tarifas');
                }
            } catch (error) {
                console.error('Error al cargar tarifas:', error);
            }
        };

        fetchTarifas();
    }, []);

    const handleDownloadPDF = async () => {
        if (loadingPDF) return;

        try {
            setLoadingPDF(true);

            const numeroCotizacion = await guardarCotizacionEnFirestore(
                form,
                totales,
                camposExtras
            );

            const datosPDF = {
                ...form,
                numeroCotizacion,
            };

            const nombreArchivo = `${numeroCotizacion}_${form.nombreCliente || "Cliente"}_${form.nombreProyecto || "Proyecto"}_${new Date().toLocaleDateString("es-CO", {
                day: "2-digit",
                month: "long",
                year: "numeric",
            })}.pdf`;

            const blob = await pdf(
                <PDFCotizacion
                    datos={datosPDF}
                    totales={totales}
                    camposExtras={camposExtras}
                />
            ).toBlob();

            const url = URL.createObjectURL(blob);
            const a = document.createElement("a");
            a.href = url;
            a.download = nombreArchivo;
            a.click();
            URL.revokeObjectURL(url);

            alert(`✅ Cotización #${numeroCotizacion} guardada y descargada correctamente.`);
        } catch (error) {
            console.error(error);
            alert("❌ Error al guardar o generar el PDF.");
        } finally {
            setLoadingPDF(false);
        }
    };

    const handleChange = (e) => {
        const { name, value, type, checked } = e.target;

        setForm((prev) => {
            if (type === 'checkbox') {
                if (name === 'maquetaVirtual') {
                    return {
                        ...prev,
                        maquetaVirtual: checked,
                        animacionLuma: checked ? 1 : '',
                    };
                }

                return { ...prev, [name]: checked };
            }

            if (name === 'descuentoValor') {
                return {
                    ...prev,
                    descuentoValor: value,
                    descuentoPorcentaje: '', // limpia el otro campo
                };
            }

            if (name === 'descuentoPorcentaje') {
                return {
                    ...prev,
                    descuentoPorcentaje: value,
                    descuentoValor: '', // limpia el otro campo
                };
            }

            return {
                ...prev,
                [name]: type === 'number' ? (value === '' ? '' : parseInt(value, 10)) : value
            };
        });
    };

    const handleEnviarCorreo = async () => {
        const numeroCotizacion = await guardarCotizacionEnFirestore(
            form,
            totales,
            camposExtras
        );
        const datosPDF = {
            ...form,
            numeroCotizacion,
        };
        const blob = await pdf(
            <PDFCotizacion datos={datosPDF} totales={totales} camposExtras={camposExtras} />
        ).toBlob();
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onloadend = async () => {
            const base64PDF = reader.result;
            const response = await fetch("https://testemail-production.up.railway.app/send-email", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    idCliente: form.idCliente,
                    email: form.correoCliente,
                    nombreCliente: form.nombreCliente,
                    nombreProyecto: form.nombreProyecto,
                    pdfBase64: base64PDF,
                }),
            });

            const result = await response.json();
            if (result.success) {
                alert("✅ Correo enviado correctamente");
            } else {
                alert("❌ Error al enviar el correo");
            }
        };
    };
    const totales = calcularTotales(form, tarifas, tasaCambio);

    const totalConvertido =
        moneda === "COP"
            ? totales.total
            : totales.total / (tasaCambio || 1);
    const totalFormateado =
        moneda === "COP"
            ? `$${Math.round(totalConvertido).toLocaleString()}`
            : `$${totalConvertido.toFixed(2)} USD`;

    return (
        <div className="card">
            <h1>Cotizador Proyectos</h1>
            {isAdmin && (
                <button
                    onClick={() => setEditandoTarifas(!editandoTarifas)}
                    style={{
                        background: editandoTarifas ? "#dc2626" : "#111111",
                        color: "white",
                        padding: "0.5rem 1rem",
                        borderRadius: "0.5rem",
                        border: "none",
                        cursor: "pointer",
                        marginBottom: "1rem",
                        fontWeight: "bold",
                    }}
                >
                    {editandoTarifas ? "Cancelar edición" : "✏️ Editar tarifas"}
                </button>
            )}
            {isAdmin && editandoTarifas && (
                <button
                    onClick={guardarTarifas}
                    style={{
                        background: "#16a34a",
                        color: "white",
                        padding: "0.75rem",
                        borderRadius: "0.5rem",
                        border: "none",
                        fontWeight: "bold",
                        cursor: "pointer",
                        marginTop: "1rem",
                    }}
                >
                    💾 Guardar tarifas
                </button>
            )}

            <fieldset
                style={{
                    border: "1px solid #ddd",
                    borderRadius: "0.75rem",
                    padding: "1.5rem",
                    marginBottom: "2rem",
                }}
            >
                <legend
                    style={{
                        fontWeight: "bold",
                        fontSize: "1.1rem",
                        padding: "0 0.5rem",
                        color: "#111111",
                    }}
                >
                    Información del Cliente
                </legend>

                {/* GRID DE DOS COLUMNAS */}
                <div className="form-grid-responsive">
                    <div>
                        <label>A nombre de:</label>
                        <input
                            type="text"
                            name="nombreCliente"
                            placeholder="Nombre del cliente"
                            value={form.nombreCliente}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Cotización realizada por:</label>
                        <input
                            type="text"
                            name="realizadaPor"
                            placeholder="Nombre del responsable"
                            value={form.realizadaPor}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Número ID cliente:</label>
                        <input
                            type="text"
                            name="idCliente"
                            placeholder="Ej: CC 12345678"
                            value={form.idCliente}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Correo electrónico:</label>
                        <input
                            type="email"
                            name="correoCliente"
                            placeholder="Ej: cliente@email.com"
                            value={form.correoCliente}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Teléfono:</label>
                        <input
                            type="tel"
                            name="telefonoCliente"
                            placeholder="Ej: 3001234567"
                            value={form.telefonoCliente}
                            onChange={handleChange}
                        />
                    </div>

                    <div>
                        <label>Nombre del proyecto:</label>
                        <input
                            type="text"
                            name="nombreProyecto"
                            placeholder="Nombre del proyecto"
                            value={form.nombreProyecto}
                            onChange={handleChange}
                        />
                    </div>
                </div>
            </fieldset>


            <fieldset style={{
                border: '1px solid #ddd',
                borderRadius: '0.75rem',
                padding: '1.5rem',
                marginBottom: '2rem'
            }}>
                <legend style={{
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    padding: '0 0.5rem',
                    color: '#111111'
                }}>
                    Diligenciar Renders
                </legend>
                <div>
                    <label
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            background: form.crearRenders ? '#e0ecff' : '#f8f8f8',
                            border: '1px solid #ccc',
                            borderRadius: '0.5rem',
                            padding: '0.75rem 1rem',
                            boxShadow: form.crearRenders
                                ? 'inset 0 0 0 2px #111111'
                                : 'inset 0 0 0 1px #ccc',
                            transition: 'all 0.25s ease',
                            fontWeight: '500',
                            color: '#111111',
                        }}
                        onClick={() =>
                            handleChange({
                                target: { name: 'crearRenders', checked: !form.crearRenders },
                            })
                        }
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                name="crearRenders"
                                checked={form.crearRenders}
                                onChange={handleChange}
                                style={{
                                    width: '18px',
                                    height: '18px',
                                    accentColor: '#111111',
                                    cursor: 'pointer',
                                }}
                            />

                            <span
                                style={{
                                    display: 'inline-block',
                                    transition: 'transform 0.3s ease',
                                    transform: form.crearRenders ? 'rotate(180deg)' : 'rotate(0deg)',
                                    fontSize: '1.2rem',
                                    color: '#111111',
                                }}
                            >
                                ▼
                            </span>
                            Crear Renders
                        </div>
                    </label>
                </div>
                {form.crearRenders && (
                    <div className="renders-grid">
                        {[
                            {
                                label: "Render plantas tipo torre:",
                                nameCantidad: "renderPlantasTipoTorre",
                                nameDescripcion: "descripcionRenderPlantasTipoTorre",
                                tarifaKey: "RenderPlantasTipoTorre",
                                image: "/renders/plantas-torre.webp",
                            },
                            {
                                label: "Render planta apto típico:",
                                nameCantidad: "renderPlantaAptoTipico",
                                nameDescripcion: "descripcionRenderPlantasAptoTipico",
                                tarifaKey: "RenderPlantaAptoTipico",
                                image: "/renders/planta-apto-tipico.webp",
                            },
                            {
                                label: "Render interiores:",
                                nameCantidad: "renderInteriores",
                                nameDescripcion: "descripcionRenderInteriores",
                                tarifaKey: "RenderInteriores",
                                image: "/renders/interiores.webp",
                            },
                            {
                                label: "Render exterior:",
                                nameCantidad: "renderExterior",
                                nameDescripcion: "descripcionRenderExterior",
                                tarifaKey: "RenderExterior",
                                image: "/renders/exterior.webp",
                            },
                            {
                                label: "Render fotomontaje:",
                                nameCantidad: "renderFotomontaje",
                                nameDescripcion: "descripcionRenderFotomontaje",
                                tarifaKey: "RenderFotomontaje",
                                image: "/renders/fotomontaje.webp",
                            },
                            {
                                label: "Render amenities:",
                                nameCantidad: "renderAmenties",
                                nameDescripcion: "descripcionRenderAmenties",
                                tarifaKey: "RenderAmenties",
                                image: "/renders/amenities.webp",
                            },
                        ].map((item, idx) => {
                            const cantidad = form[item.nameCantidad];
                            const tarifa = tarifas?.[item.tarifaKey] || 0;
                            // const total = cantidad * tarifa;

                            return (
                                <div
                                    key={idx}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                        gap: "0.5rem",
                                        padding: "1rem",
                                        border: "1px solid #eee",
                                        borderRadius: "0.5rem",
                                        background: "#fafafa",
                                    }}
                                >
                                    {/* TÍTULO */}
                                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                                        <span style={{ fontWeight: "600", color: "#111" }}>
                                            {item.label}
                                        </span>

                                        <InfoTooltip image={item.image} />
                                    </div>

                                    {/* TARIFA */}
                                    {isAdmin && (
                                        editandoTarifas ? (
                                            <input
                                                type="number"
                                                value={tarifa}
                                                onChange={(e) =>
                                                    setTarifas({
                                                        ...tarifas,
                                                        [item.tarifaKey]: Number(e.target.value),
                                                    })
                                                }
                                                style={{
                                                    width: "140px",
                                                    padding: "0.4rem",
                                                    border: "1px solid #ccc",
                                                    borderRadius: "4px",
                                                }}
                                            />
                                        ) : (
                                            <span style={{ color: "#666", fontWeight: "bold" }}>
                                                ${tarifa.toLocaleString()}
                                            </span>
                                        )
                                    )}
                                    {/* INPUTS */}
                                    <div
                                        style={{
                                            display: "flex",
                                            flexWrap: "wrap",
                                            gap: "0.5rem",
                                        }}
                                    >
                                        <input
                                            type="number"
                                            name={item.nameCantidad}
                                            min="0"
                                            value={cantidad}
                                            onChange={handleChange}
                                            placeholder="Cantidad"
                                            style={{
                                                flex: "1",
                                                minWidth: "100px",
                                            }}
                                        />

                                        <input
                                            type="text"
                                            name={item.nameDescripcion}
                                            value={form[item.nameDescripcion] || ""}
                                            onChange={handleChange}
                                            placeholder="Descripción"
                                            style={{
                                                flex: "2",
                                                minWidth: "160px",
                                            }}
                                        />
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                )}

                {form.crearRenders && (
                    <div style={{ marginTop: "1rem" }}>
                        <div style={{
                            display: "flex",
                            flexDirection: "column",
                            gap: "0.5rem",
                            padding: "1rem",
                            border: "1px solid #eee",
                            borderRadius: "0.5rem",
                            background: "#fafafa",
                        }}>
                            <div className="label-tooltip">
                                <span className="label-text">
                                    Plantas arquitectónicas con cotas apto típico:
                                </span>

                                <div className="tooltip-wrapper">
                                    <InfoTooltip image="/renders/plantas-arquitectonicas-cotas.webp" />
                                </div>
                            </div>


                            <div>
                                {isAdmin && editandoTarifas ? (
                                    <input
                                        type="number"
                                        value={tarifas?.PlantasArquitectonicasConCotasAptoTipico}
                                        onChange={(e) =>
                                            setTarifas({
                                                ...tarifas,
                                                PlantasArquitectonicasConCotasAptoTipico: Number(e.target.value),
                                            })
                                        }
                                        style={{
                                            width: "160px",
                                            padding: "0.4rem",
                                            border: "1px solid #ccc",
                                            borderRadius: "4px",
                                        }}
                                    />
                                ) : (
                                    isAdmin && (
                                        <span style={{ color: "#666", fontWeight: "bold" }}>
                                            ${tarifas?.PlantasArquitectonicasConCotasAptoTipico?.toLocaleString() || 0}
                                        </span>
                                    )
                                )}
                            </div>
                            <div style={{
                                display: "flex",
                                flexWrap: "wrap",
                                gap: "0.5rem"
                            }}>
                                <input
                                    type="number"
                                    name="plantasArquitectonicasCotas"
                                    min="0"
                                    value={form.plantasArquitectonicasCotas}
                                    onChange={handleChange}
                                    placeholder="Cantidad"
                                    style={{
                                        flex: "1",
                                        minWidth: "100px"
                                    }}
                                />

                                <input
                                    type="text"
                                    name="descripcionRenderArquitectonicas"
                                    value={form.descripcionRenderArquitectonicas || ""}
                                    onChange={handleChange}
                                    placeholder="Descripción"
                                    style={{
                                        flex: "2",
                                        minWidth: "160px"
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                )}
            </fieldset>

            <fieldset style={{
                border: '1px solid #ddd',
                borderRadius: '0.75rem',
                padding: '1.5rem',
                marginBottom: '2rem'
            }}>
                <legend style={{
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    padding: '0 0.5rem',
                    color: '#111111'
                }}>
                    360 e info cotizacón
                </legend>
                <div
                    style={{
                        display: "grid",
                        gridTemplateColumns: "1fr 1fr",
                        gap: "1.5rem",
                        marginTop: "1rem",
                    }}
                >
                    {/* 🔹 INTERIORES 360 */}
                    <div style={{ display: "flex", flexDirection: "column" }}>

                        {/* TÍTULO CON ALTURA FIJA */}
                        <div
                            style={{
                                minHeight: "60px", // 🔥 asegura alineación
                                //marginBottom: "0.75rem",
                                display: "flex",
                                flexDirection: "column",
                                justifyContent: "flex-start",
                                fontWeight: "600",
                            }}
                        >
                            <span>Interiores 360 x nodo</span>

                            {isAdmin && editandoTarifas ? (
                                <input
                                    type="number"
                                    value={tarifas?.Interiores360xNodo}
                                    onChange={(e) =>
                                        setTarifas({
                                            ...tarifas,
                                            Interiores360xNodo: Number(e.target.value),
                                        })
                                    }
                                    style={{
                                        width: "160px",
                                        padding: "0.4rem",
                                        border: "1px solid #ccc",
                                        borderRadius: "4px",
                                        marginTop: "0.4rem",
                                    }}
                                />
                            ) : (
                                isAdmin && (
                                    <span style={{ color: "#666", fontWeight: "bold", marginTop: "0.4rem" }}>
                                        ${tarifas?.Interiores360xNodo?.toLocaleString() || 0}
                                    </span>
                                )
                            )}
                        </div>

                        {/* INPUT */}
                        <input
                            type="number"
                            name="interiores360"
                            min={form.esCotizacionNueva === "Sí" ? 4 : 0}
                            value={form.interiores360}
                            onChange={handleChange}
                            placeholder="Ej: 4"
                            style={{
                                padding: "0.6rem",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                            }}
                        />

                        <div style={{ marginTop: "1.5rem" }}>
                            <label
                                style={{
                                    display: "block",
                                    marginBottom: "0.5rem",
                                    fontWeight: "600",
                                    color: "#111"
                                }}
                            >
                                Incluye
                            </label>
                            <input
                                type="text"
                                name="incluye"
                                value={form.incluye || ""}
                                onChange={handleChange}
                                placeholder="Ej: Postproducción de imágenes, correcciones básicas, entrega en alta resolución"
                                style={{
                                    width: "100%",
                                    padding: "0.6rem",
                                    borderRadius: "6px",
                                    border: "1px solid #ccc"
                                }}
                            />
                        </div>
                    </div>

                    {/* 🔹 SELECT COTIZACIÓN */}
                    <div style={{ display: "flex", flexDirection: "column" }}>
                        {/* TÍTULO CON MISMA ALTURA */}
                        <div
                            style={{
                                minHeight: "60px", // 🔥 misma altura que el otro
                                //marginBottom: "0.75rem",
                                display: "flex",
                                alignItems: "flex-start",
                                fontWeight: "600",
                            }}
                        >
                            ¿Es cotización nueva?
                        </div>
                        <select
                            name="esCotizacionNueva"
                            value={form.esCotizacionNueva}
                            onChange={handleChange}
                            style={{
                                padding: "0.6rem",
                                borderRadius: "6px",
                                border: "1px solid #ccc",
                            }}
                        >
                            <option value="Sí">Sí</option>
                            <option value="No">No</option>
                        </select>
                    </div>
                </div>

            </fieldset>

            <fieldset style={{
                border: '1px solid #ddd',
                borderRadius: '0.75rem',
                padding: '1.5rem',
                marginBottom: '2rem'
            }}>
                <legend style={{
                    fontWeight: 'bold',
                    fontSize: '1.1rem',
                    padding: '0 0.5rem',
                    color: '#111111'
                }}>
                    Maqueta virtual
                </legend>
                <div>
                    <label
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'space-between',
                            cursor: 'pointer',
                            background: form.maquetaVirtual ? '#e0ecff' : '#f8f8f8',
                            border: '1px solid #ccc',
                            borderRadius: '0.5rem',
                            padding: '0.75rem 1rem',
                            boxShadow: form.maquetaVirtual
                                ? 'inset 0 0 0 2px #111111'
                                : 'inset 0 0 0 1px #ccc',
                            transition: 'all 0.25s ease',
                            fontWeight: '500',
                            color: '#111111',
                        }}
                        onClick={() =>
                            handleChange({
                                target: { name: 'maquetaVirtual', checked: !form.maquetaVirtual },
                            })
                        }
                    >
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <input
                                type="checkbox"
                                name="maquetaVirtual"
                                checked={form.maquetaVirtual}
                                onChange={handleChange}
                                style={{
                                    width: '18px',
                                    height: '18px',
                                    accentColor: '#111111',
                                    cursor: 'pointer',
                                }}
                            />

                            <span
                                style={{
                                    display: 'inline-block',
                                    transition: 'transform 0.3s ease',
                                    transform: form.maquetaVirtual ? 'rotate(180deg)' : 'rotate(0deg)',
                                    fontSize: '1.2rem',
                                    color: '#111111',
                                }}
                            >
                                ▼
                            </span>
                            Campos maqueta virtual
                        </div>
                    </label>
                </div>
                {form.maquetaVirtual && (
                    <div className='maqueta-grid'>
                        {/* 🔝 BLOQUE PRINCIPAL DESTACADO */}
                        <div
                            style={{
                                gridColumn: "1 / -1",
                                display: "grid",
                                gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
                                gap: "1.5rem",
                                padding: "1.5rem",
                                background: "#f4f6f9",
                                borderRadius: "12px",
                                border: "1px solid #e5e7eb",
                            }}
                        >
                            {[
                                {
                                    label: "🏠 Numero de unidades habitacionales por proyecto (apartamentos o casas):",
                                    name: "unidadesHabitacionales",
                                    value: form.unidadesHabitacionales,
                                },
                                {
                                    label: "🏢 Número de Torres del proyecto:",
                                    name: "numeroTorres",
                                    value: form.numeroTorres,
                                },
                                {
                                    label: "🧱 Renders Stills para disponibilidad en fachada:",
                                    name: "rendersDisponibilidad",
                                    value: form.rendersDisponibilidad,
                                },
                                {
                                    label: "🚁 Animaciones vuelo a torre:",
                                    name: "vueloTorre",
                                    value: form.vueloTorre,
                                },
                            ].map((item, i) => (
                                <label
                                    key={i}
                                    style={{
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    {/* CONTENEDOR DEL TÍTULO CON ALTURA FIJA */}
                                    <div
                                        style={{
                                            minHeight: "56px", // 🔥 fuerza misma altura
                                            display: "flex",
                                            alignItems: "flex-start",
                                        }}
                                    >
                                        <span
                                            style={{
                                                fontWeight: "700",
                                                fontSize: "0.95rem",
                                                color: "#111",
                                                lineHeight: "1.2rem",
                                            }}
                                        >
                                            {item.label}
                                        </span>
                                    </div>

                                    <input
                                        type="number"
                                        min="0"
                                        name={item.name}
                                        value={item.value || ""}
                                        onChange={handleChange}
                                        placeholder="Cantidad"
                                        style={{
                                            padding: "0.9rem",
                                            fontSize: "1.05rem",
                                            borderRadius: "8px",
                                            border: "1px solid #ccc",
                                            background: "#fff",
                                        }}
                                    />
                                </label>
                            ))}
                        </div>
                        {/* COLUMNA 1 */}

                        {[
                            {
                                label: "Animación intro a master plan punto 0:",
                                tarifaKey: "AnimacionIntro",
                                name: "animacionIntro",
                                value: form.animacionIntro,
                                calc: (tarifas?.AnimacionIntro || 0) * (form.animacionIntro || 0),
                            },
                            {
                                label:
                                    "Videos animaciones de 3seg vuelos spins (siempre son 3 para el master plan):",
                                tooltip:
                                    "Animaciones Spin para girar alrededor del proyecto, posiciones 0, 120 y 240 grados.",
                                tarifaKey: "VideoAnimacion",
                                name: "videoAnimacion",
                                value: form.videoAnimacion,
                                calc:
                                    (tarifas?.VideoAnimacion || 0) * (form.videoAnimacion || 0),
                            },
                            {
                                label: "Animación vuelo a torre:",
                                tooltip:
                                    "Animaciones desde puntos 0, 120 y 240 hacia cada torre.",
                                tarifaKey: "AnimacionVueloATorre",
                                name: "animacionVuelo",
                                value: form.vueloTorre * form.numeroTorres || 0,
                                readOnly: true,
                                calc:
                                    (tarifas?.AnimacionVueloATorre || 0) *
                                    (form.vueloTorre * form.numeroTorres || 0),
                            },
                            {
                                label: "Renders Stills para Disponibilidad:",
                                tooltip:
                                    "Mínimo 2 stills por torre para mostrar disponibilidad.",
                                tarifaKey: "RendersStillsParaDisponiblidad",
                                name: "renderStill",
                                value: form.rendersDisponibilidad * form.numeroTorres || 0,
                                readOnly: true,
                                calc:
                                    (tarifas?.RendersStillsParaDisponiblidad || 0) *
                                    (form.rendersDisponibilidad * form.numeroTorres || 0),
                            },
                            {
                                label: "Animación para Luma IA:",
                                tarifaKey: "AnimacionParaLumaIA",
                                name: "animacionLuma",
                                value: form.animacionLuma,
                                calc:
                                    (tarifas?.AnimacionParaLumaIA || 0) *
                                    (form.animacionLuma || 0),
                            },
                        ].map((item, index) => {
                            const tarifa = tarifas?.[item.tarifaKey] || 0;
                            return (
                                <div
                                    key={index}
                                    style={{
                                        padding: "1rem",
                                        borderRadius: "10px",
                                        border: "1px solid #e5e7eb",
                                        display: "flex",
                                        flexDirection: "column",
                                    }}
                                >
                                    {/* 🔹 TÍTULO CON ALTURA UNIFORME */}
                                    <div
                                        style={{
                                            minHeight: "36px", // 🔥 fuerza misma altura en todos
                                            alignItems: "flex-start",
                                            marginBottom: "0.75rem",
                                            fontWeight: "600",
                                            color: "#111",
                                            lineHeight: "1.2rem",
                                        }}
                                    >
                                        {item.label}
                                        {item.tooltip && (
                                            <InfoTooltip text={item.tooltip} />
                                        )}
                                    </div>

                                    {/* 🔹 CONTENIDO */}
                                    <div
                                        style={{
                                            display: "grid",
                                            gap: "0.75rem",
                                        }}
                                    >
                                        {/* Tarifa */}
                                        <div>
                                            {isAdmin && editandoTarifas ? (
                                                <input
                                                    type="number"
                                                    value={tarifa}
                                                    onChange={(e) =>
                                                        setTarifas({
                                                            ...tarifas,
                                                            [item.tarifaKey]: Number(e.target.value),
                                                        })
                                                    }
                                                    style={{
                                                        width: "100%",
                                                        padding: "0.5rem",
                                                        borderRadius: "6px",
                                                        border: "1px solid #ccc",
                                                    }}
                                                />
                                            ) : (
                                                isAdmin && (
                                                    <span style={{ fontWeight: "600", color: "#555" }}>
                                                        ${tarifa.toLocaleString()}
                                                    </span>
                                                )
                                            )}
                                        </div>

                                        {/* Cantidad */}
                                        <input
                                            type="number"
                                            min="0"
                                            name={item.name}
                                            value={item.value}
                                            readOnly={item.readOnly}
                                            onChange={handleChange}
                                            style={{
                                                width: "100%",
                                                padding: "0.6rem",
                                                borderRadius: "6px",
                                                border: "1px solid #ccc",
                                            }}
                                        />

                                        {/* Total */}
                                        <div style={{ fontWeight: "700", textAlign: "right" }}>
                                            Subtotal: ${Math.round(item.calc || 0).toLocaleString()}
                                        </div>
                                    </div>
                                </div>

                            );
                        })}
                        {/* COLUMNA 2 */}
                        <div style={{ display: "flex", flexDirection: "column", gap: "1.25rem" }}>
                            <label style={{ display: "flex", flexDirection: "column", gap: "0.35rem" }}>
                                {isAdmin && (
                                    <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                                        <span style={{ fontWeight: "600" }}>
                                            TRM actual (USD → COP)
                                        </span>

                                        {tasaCambioAuto && (
                                            <>
                                                <span style={{ color: "#888", fontSize: "0.9rem" }}>
                                                    {Math.round(tasaCambioAuto).toLocaleString()}
                                                </span>

                                                <button
                                                    type="button"
                                                    onClick={() => setTasaCambio(Math.round(tasaCambioAuto))}
                                                    style={{
                                                        padding: "4px 8px",
                                                        fontSize: "0.8rem",
                                                        cursor: "pointer"
                                                    }}
                                                >
                                                    Seleccionar
                                                </button>
                                            </>
                                        )}
                                    </div>
                                )}
                                {isAdmin && (
                                    <input
                                        type="text"
                                        inputMode="decimal"
                                        value={tasaCambio}
                                        onChange={e => {
                                            let value = e.target.value.replace(",", ".").replace(/[^0-9.]/g, "");
                                            const parts = value.split(".");
                                            if (parts.length > 2) value = parts[0] + "." + parts.slice(1).join("");
                                            if (value.startsWith("0") && !value.startsWith("0.") && value.length > 1)
                                                value = value.replace(/^0+/, "");
                                            setTasaCambio(value);
                                        }}
                                        style={{
                                            // width: "60%",
                                            // maxWidth: "260px",
                                            padding: "0.75rem",
                                            border: "1px solid #ccc",
                                            borderRadius: "0.5rem",
                                        }}
                                    />
                                )}
                            </label>
                        </div>
                    </div>
                )}
                {form.maquetaVirtual && (
                    <div>
                        <label style={{ display: 'block', marginBottom: '0.5rem', marginTop: '0.5rem' }}>
                            Wire transfer fee
                        </label>
                        {isAdmin && editandoTarifas ? (
                            <input
                                type="number"
                                value={tarifas?.WireTransferFee || 0}
                                onChange={(e) =>
                                    setTarifas({
                                        ...tarifas,
                                        WireTransferFee: Number(e.target.value),
                                    })
                                }
                                style={{
                                    width: "100%",
                                    padding: "0.75rem",
                                    border: "1px solid #ccc",
                                    borderRadius: "0.5rem",
                                }}
                            />
                        ) : (
                            isAdmin && (
                                <input
                                    type="text"
                                    value={
                                        tarifas?.WireTransferFee !== undefined
                                            ? `${tarifas.WireTransferFee} COP`
                                            : "Cargando..."
                                    }
                                    readOnly
                                    style={{
                                        width: "100%",
                                        padding: "0.75rem",
                                        border: "1px solid #ccc",
                                        borderRadius: "0.5rem",
                                        backgroundColor: "#f9f9f9",
                                        color: "#333",
                                    }}
                                />
                            )
                        )}
                        <div style={{ marginTop: '0.5rem', fontWeight: 'bold', color: '#111111' }}>
                            Maqueta + Transfer Fee: ${Math.round(
                                (totales.precioCOPUnidades || 0) + (totales.tarifaTransferencia || 0)
                            ).toLocaleString()} COP
                        </div>
                    </div>
                )}
                {form.maquetaVirtual && (
                    <div style={{ marginTop: '1rem', marginBottom: '1rem' }}>
                        <label style={{ display: 'flex', alignItems: 'center', gap: '0.5rem', marginBottom: '0.5rem' }}>
                            Incluir Vuelo de drone (COP)
                            <input
                                type="checkbox"
                                name="incluirVueloDrone"
                                checked={form.incluirVueloDrone}
                                onChange={handleChange}
                            />
                        </label>
                        <input
                            type="number"
                            name="vueloDrone"
                            value={form.vueloDrone}
                            onChange={handleChange}
                            min="0"
                            step="1000"
                            disabled={!form.incluirVueloDrone}
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                border: '1px solid #ccc',
                                borderRadius: '0.5rem',
                                backgroundColor: form.incluirVueloDrone ? 'white' : '#f0f0f0'
                            }}
                        />
                    </div>
                )}
                {form.maquetaVirtual && (
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                            Porcentaje de Administración de servicio con terceros
                        </label>
                        {isAdmin && editandoTarifas ? (
                            <input
                                type="number"
                                value={tarifas?.PorcentajeAdministracionServicoTerceros || 0}
                                onChange={(e) =>
                                    setTarifas({
                                        ...tarifas,
                                        PorcentajeAdministracionServicoTerceros: Number(e.target.value),
                                    })
                                }
                                style={{
                                    width: "100%",
                                    padding: "0.75rem",
                                    border: "1px solid #ccc",
                                    borderRadius: "0.5rem",
                                }}
                            />
                        ) : (
                            isAdmin && (
                                <input
                                    type="text"
                                    value={
                                        tarifas?.PorcentajeAdministracionServicoTerceros !== undefined
                                            ? `${tarifas.PorcentajeAdministracionServicoTerceros}%`
                                            : "Cargando..."
                                    }
                                    readOnly
                                    style={{
                                        width: "100%",
                                        padding: "0.75rem",
                                        border: "1px solid #ccc",
                                        borderRadius: "0.5rem",
                                        backgroundColor: "#f9f9f9",
                                        color: "#333",
                                    }}
                                />
                            )
                        )}

                    </div>
                )}
                {form.maquetaVirtual && (
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                            Precio sitio Web (Proveedor tecnológico)
                        </label>
                        <input
                            type="text"
                            value={
                                totales?.precioSitioWeb
                                    ? `$${totales.precioSitioWeb.toLocaleString()} COP`
                                    : 'Calculando...Llenar campo 🏠 Número de unidades habitacionales'
                            }
                            readOnly
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                border: '1px solid #ccc',
                                borderRadius: '0.5rem',
                                backgroundColor: '#f9f9f9',
                                color: '#333'
                            }}
                        />
                    </div>
                )}
                {form.maquetaVirtual && (
                    <div style={{ marginBottom: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                            Precio anual de mantenimiento después del primer año
                        </label>
                        <input
                            type="text"
                            value={
                                totales?.precioAnualMantenimiento
                                    ? `$${totales.precioAnualMantenimiento.toLocaleString()} COP`
                                    : 'Cargando...'
                            }
                            readOnly
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                border: '1px solid #ccc',
                                borderRadius: '0.5rem',
                                backgroundColor: '#f9f9f9',
                                color: '#333'
                            }}
                        />
                    </div>
                )}
            </fieldset>
            <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr 1fr',
                gap: '1.5rem',
                marginTop: '1.5rem'
            }}>
                <div>
                    <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                        Descuento en valor (COP)
                    </label>
                    <input
                        type="number"
                        name="descuentoValor"
                        min="0"
                        value={form.descuentoValor}
                        onChange={handleChange}
                        placeholder="Ej: 50000"
                    />
                </div>

                <div>
                    <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                        Descuento en porcentaje (%)
                    </label>
                    <input
                        type="number"
                        name="descuentoPorcentaje"
                        min="0"
                        max="100"
                        value={form.descuentoPorcentaje}
                        onChange={handleChange}
                        placeholder="Ej: 10"
                    />
                </div>
            </div>

            <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                    Forma de pago
                </label>
                <select
                    name="formaPago"
                    value={form.formaPago}
                    onChange={handleChange}
                    style={{
                        width: '100%',
                        padding: '0.75rem',
                        border: '1px solid #ccc',
                        borderRadius: '0.5rem'
                    }}
                >
                    <option value="Completo">Completo</option>
                    <option value="Cuotas">En cuotas</option>
                </select>
                {form.formaPago === 'Cuotas' && (
                    <div style={{ marginTop: '1rem' }}>
                        <label style={{ display: 'block', marginBottom: '0.5rem' }}>
                            Detalle del plan de pago
                        </label>
                        <textarea
                            name="notaPagoCuotas"
                            value={form.notaPagoCuotas}
                            onChange={handleChange}
                            placeholder="Ej: El pago se realizará en 3 cuotas mensuales del 33.3% cada una."
                            style={{
                                width: '100%',
                                padding: '0.75rem',
                                border: '1px solid #ccc',
                                borderRadius: '0.5rem',
                                minHeight: '80px',
                                resize: 'vertical'
                            }}
                        />
                    </div>
                )}

            </div>

            <div style={{ marginTop: '2rem' }}>
                <h3 style={{ marginBottom: '1rem', color: '#111111' }}>Campos adicionales</h3>

                {camposExtras.map((campo, idx) => (
                    <div
                        key={idx}
                        style={{
                            display: 'flex',
                            gap: '1rem',
                            marginBottom: '1rem',
                            alignItems: 'center',
                        }}
                    >
                        <input
                            type="text"
                            placeholder="Nombre del campo"
                            value={campo.nombre}
                            onChange={(e) => actualizarCampoExtra(idx, 'nombre', e.target.value)}
                            style={{
                                flex: 1,
                                padding: '0.75rem',
                                border: '1px solid #ccc',
                                borderRadius: '0.5rem',
                            }}
                        />
                        <input
                            type="text"
                            placeholder="Valor"
                            value={campo.valor}
                            onChange={(e) => actualizarCampoExtra(idx, 'valor', e.target.value)}
                            style={{
                                flex: 1,
                                padding: '0.75rem',
                                border: '1px solid #ccc',
                                borderRadius: '0.5rem',
                            }}
                        />
                        <button
                            type="button"
                            onClick={() => eliminarCampoExtra(idx)}
                            style={{
                                backgroundColor: '#ef4444',
                                color: 'white',
                                border: 'none',
                                padding: '0.6rem 1rem',
                                borderRadius: '0.5rem',
                                cursor: 'pointer',
                            }}
                        >
                            ✕
                        </button>
                    </div>
                ))}

                <button
                    type="button"
                    onClick={agregarCampoExtra}
                    style={{
                        backgroundColor: '#111111',
                        color: 'white',
                        padding: '0.75rem 1rem',
                        border: 'none',
                        borderRadius: '0.5rem',
                        cursor: 'pointer',
                        fontWeight: 'bold',
                    }}
                >
                    + Agregar campo
                </button>
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <label style={{ display: 'block', marginBottom: '0.5rem', fontWeight: 'bold' }}>
                    Retenciones e impuestos
                </label>

                <div style={{ display: "flex" }}>
                    <label
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            cursor: "pointer",
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={form.retencionIVA}
                            onChange={(e) =>
                                setForm({ ...form, retencionIVA: e.target.checked })
                            }
                        />

                        <span
                            style={{
                                fontWeight: "600",
                                color: "#111",
                                whiteSpace: "nowrap", // 🔥 evita salto
                            }}
                        >
                            Aplicar IVA (19%)
                        </span>
                    </label>
                    <div style={{ marginLeft: "8px" }}>
                        <InfoTooltip text="Se adiciona el 19% de IVA sobre el valor total del servicio." />
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    <label
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            cursor: "pointer",
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={form.retencionReteFuente}
                            onChange={(e) => setForm({ ...form, retencionReteFuente: e.target.checked })}
                        />

                        <span
                            style={{
                                fontWeight: "600",
                                color: "#111",
                                whiteSpace: "nowrap", // 🔥 evita salto
                            }}
                        >
                            Aplicar ReteFuente (2.5%)
                        </span>
                    </label>
                    <div style={{ marginLeft: "8px" }}>
                        <InfoTooltip text="Se descuenta el 2.5% del valor antes de IVA como retención en la fuente, según normativa tributaria vigente." />
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    <label
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            cursor: "pointer",
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={form.retencionReteICA}
                            onChange={(e) => setForm({ ...form, retencionReteICA: e.target.checked })}
                        />

                        <span
                            style={{
                                fontWeight: "600",
                                color: "#111",
                                whiteSpace: "nowrap", // 🔥 evita salto
                            }}
                        >
                            Aplicar ReteICA (0.9%)
                        </span>
                    </label>
                    <div style={{ marginLeft: "8px" }}>
                        <InfoTooltip text="Se descuenta el 0.9% correspondiente al impuesto de Industria y Comercio (ICA), aplicado sobre el valor del servicio." />
                    </div>
                </div>
                <div style={{ display: "flex" }}>
                    <label
                        style={{
                            display: "flex",
                            alignItems: "center",
                            gap: "0.5rem",
                            cursor: "pointer",
                        }}
                    >
                        <input
                            type="checkbox"
                            checked={form.retencionReteIVA}
                            onChange={(e) => setForm({ ...form, retencionReteIVA: e.target.checked })}
                        />
                        <span
                            style={{
                                fontWeight: "600",
                                color: "#111",
                                whiteSpace: "nowrap", // 🔥 evita salto
                            }}
                        >
                            Aplicar ReteIVA (15% del IVA)
                        </span>
                    </label>
                    <div style={{ marginLeft: "8px" }}>
                        <InfoTooltip text="Se retiene el 15% del valor generado por concepto de IVA en la factura." />
                    </div>
                </div>
            </div>
            <div
                className="total"
                ref={totalRef}
            >
                <label>
                    Total estimado: {totalFormateado}
                </label>

                <button
                    type="button"
                    onClick={() =>
                        setMoneda(moneda === "COP" ? "USD" : "COP")
                    }
                    style={{
                        padding: "6px 12px",
                        cursor: "pointer",
                        backgroundColor: "#111",
                        color: "#fff",
                        border: "none",
                        borderRadius: "4px"
                    }}
                >
                    {moneda === "COP" ? "Cambiar a USD" : "Cambiar a COP"}
                </button>
            </div>


            {mostrarFlotante && (
                <div style={{
                    position: 'fixed',
                    bottom: '20px',
                    right: '20px',
                    background: '#111111',
                    color: '#fff',
                    padding: '0.75rem 1.5rem',
                    borderRadius: '0.5rem',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.2)',
                    zIndex: 1000,
                    fontWeight: 'bold',
                }}>
                    Total: ${totales.total.toLocaleString()}
                </div>
            )}

            <button
                className="btn"
                disabled={isGenerating}
                style={{ backgroundColor: '#10b981', marginBottom: '10px' }}
                onClick={() => setMostrarPreview(true)}
            >
                Vista previa PDF
            </button>


            {mostrarPreview && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        width: "100%",
                        height: "100%",
                        backgroundColor: "rgba(0,0,0,0.6)",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        zIndex: 1000,
                    }}
                >
                    <div
                        style={{
                            backgroundColor: "white",
                            padding: "1rem",
                            borderRadius: "8px",
                            width: "90%",
                            height: "90%",
                            display: "flex",
                            flexDirection: "column",
                        }}
                    >

                        <div
                            style={{
                                display: "flex",
                                justifyContent: "flex-end",
                                gap: "1rem",
                                marginBottom: "1rem",
                            }}
                        >
                            <button
                                onClick={async () => {
                                    const confirmar = window.confirm("¿Seguro que desea enviar la cotización?");
                                    if (!confirmar) return; // si el usuario presiona "Cancelar", no hace nada

                                    try {
                                        // Aquí va tu lógica de envío
                                        await handleEnviarCorreo();
                                        alert("Cotización enviada correctamente ✅");
                                    } catch (error) {
                                        alert("Error al enviar la cotización ❌");
                                        console.error(error);
                                    }
                                }}
                                style={{
                                    background: "#16a34a",
                                    color: "white",
                                    padding: "0.5rem 1rem",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                            >
                                Enviar
                            </button>

                            <button
                                onClick={handleDownloadPDF}
                                disabled={loadingPDF}
                                style={{
                                    background: loadingPDF ? "#444" : "#111111",
                                    color: "white",
                                    padding: "0.6rem 1.2rem",
                                    border: "none",
                                    borderRadius: "6px",
                                    cursor: loadingPDF ? "not-allowed" : "pointer",
                                    display: "flex",
                                    alignItems: "center",
                                    justifyContent: "center",
                                    gap: "0.5rem",
                                    minWidth: "130px",
                                }}
                            >
                                {loadingPDF ? (
                                    <>
                                        <span
                                            style={{
                                                width: "16px",
                                                height: "16px",
                                                border: "2px solid #fff",
                                                borderTop: "2px solid transparent",
                                                borderRadius: "50%",
                                                animation: "spin 0.8s linear infinite",
                                            }}
                                        />
                                        Descargando...
                                    </>
                                ) : (
                                    "Descargar"
                                )}
                            </button>


                            <button
                                onClick={() => setMostrarPreview(false)}
                                style={{
                                    background: "#111111",
                                    color: "white",
                                    padding: "0.5rem 1rem",
                                    border: "none",
                                    borderRadius: "4px",
                                    cursor: "pointer",
                                }}
                            >
                                Cerrar
                            </button>
                        </div>

                        <div style={{ flex: 1, border: "1px solid #ccc" }}>
                            <PDFViewer width="100%" height="100%">
                                <PDFCotizacion datos={form} totales={totales} camposExtras={camposExtras} />
                            </PDFViewer>
                        </div>
                    </div>
                </div>
            )}
        </div>

    );
}

export default CotizadorForm;
